import React, { useState } from 'react'
import { DownloadIcon } from '@mote/assets/icons'
import type { MoteActionButtonProps } from '../MoteActionButton'
import { MoteActionButton } from '../MoteActionButton'

export interface MoteDownloadButtonProps
  extends Pick<MoteActionButtonProps, 'textPosition' | 'size'> {
  onDownload: () => void
}

export const MoteDownloadButton = (
  props: MoteDownloadButtonProps
): JSX.Element => {
  const [loading, setLoading] = useState(false)

  async function handleDownload() {
    setLoading(true)
    try {
      await props.onDownload()
    } catch {}
    setLoading(false)
  }

  return (
    <MoteActionButton
      {...{
        onClick: handleDownload,
        loading,
        size: props.size,
        text: 'Download',
        icon: <DownloadIcon />,
        id: 'download-mote-button',
        ariaLabel: 'Download',
        textPosition: props.textPosition
      }}
    />
  )
}
